export default __webpack_public_path__ + "static/media/UploadIcon.f9775b14.svg";